import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ReportHeader from './report-header.jsx';
import "../../../styles/Auth/report.css";
import Footer from "../Footer/Footer-page.jsx";
import { getDateRange } from "../../../utils/get-DateRange.js";

const Report = () => {
    const location = useLocation();
    const today = new Date().toISOString().split("T")[0];

    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [dateRange, setDateRange] = useState("Today");

    const mapQueryToDateRangeLabel = (paramRange) => {
        if (!paramRange) return null;
        const lower = paramRange.toLowerCase();
        if (lower === 'today') return 'Today';
        if (lower === 'last7days' || lower === 'weekly' || lower === 'week' || lower === 'last_7_days') return 'Last 7 Days';
        if (lower === 'currentmonth' || lower === 'monthly' || lower === 'month' || lower === 'current_month') return 'Current Month';
        if (lower === 'currentfy' || lower === 'yearly' || lower === 'year' || lower === 'current_fy') return 'Current FY';
        if (lower === 'custom') return 'Custom';
        return paramRange;
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const paramDateRange = queryParams.get("dateRange");
        const paramFromDate = queryParams.get("fromDate");
        const paramToDate = queryParams.get("toDate");

        if (paramDateRange) {
            const mappedRange = mapQueryToDateRangeLabel(paramDateRange);
            if (mappedRange === "Custom") {
                setDateRange("Custom");
                if (paramFromDate && paramToDate) {
                    setStartDate(paramFromDate);
                    setEndDate(paramToDate);
                }
            } else if (mappedRange) {
                setDateRange(mappedRange);
                const { startDate: s, endDate: eD } = getDateRange(mappedRange);
                setStartDate(s);
                setEndDate(eD);
            }
        }
    }, [location.search]);

    useEffect(() => {
        const path = window.location.pathname;
        if (path.includes("/reports/eod")) {
            if (location.state?.pendingEodDate) {
                const pendingDateStr = location.state.pendingEodDate.split("T")[0];
                setStartDate(pendingDateStr);
                setEndDate(pendingDateStr);
                setDateRange("Custom");
            } else if (dateRange !== "Today") {
                setDateRange("Today");
                const { startDate: s, endDate: eD } = getDateRange("Today");
                setStartDate(s);
                setEndDate(eD);
            }
        }
    }, [location.pathname, location.state]);

    return (
        <div className='report-layout'>
            <div className='report-content'>

                <main className='report-main'>
                    <ReportHeader
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        dateRange={dateRange}
                        setDateRange={setDateRange}
                    />
                </main>
                <div className='report-body-container'>
                    <Outlet context={{ startDate, endDate, dateRange }} />
                </div>
                <Footer sx={{ mt: 4, mb: 2 }} />
            </div>
        </div>
    );
};

export default Report;